import { ControlPosition, MapControl } from "@vis.gl/react-google-maps";
import React, { useEffect, useRef, useState } from "react";
import { FormSelect, ListGroup, Spinner, ThemeProvider } from "react-bootstrap";
import { ThemeContext } from "../../contexts/ThemeContext";
import { DebounceInput } from "react-debounce-input";
import api from "../../api";
import { Image, Map } from "react-feather";

const FloorplanSelectControl = ({
  showDefault = false,
  showMap = false,
  hideSitePlans = true,
  defaultId = null,
  asset = null,
  right = false,
  onSelect,
  cancelOption,
  showOptions,
  noResult,
}) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchString, setSearchString] = useState("");
  const [showing, setShowing] = useState(false);
  const [current, setCurrent] = useState(null);
  const firstLoad = useRef(false);
  const isUnmount = useRef(false);

  const onSearch = (search) => {
    setLoading(true);
    api
      .get(
        `floorplans?page=1&limit=100&filter=${search}${
          showDefault ? `&parentId=${asset}` : ""
        }`
      )
      .then((res) => {
        if (isUnmount.current) return;

        var data = res.data;
        // Filter out the site plans ()
        if (hideSitePlans) {
          data = res.data.filter((item) => !(item.altitude === -1));
        }
        setData(data);
        setLoading(false);

        if (!firstLoad.current) {
          if (showDefault) {
            var defaultPlan =
              data.filter((item) => item.id === defaultId)[0] ||
              (defaultId === "" ? null : data[0] ?? null);
            onSelect && onSelect(defaultPlan);
            setSearchString(defaultPlan?.floorPlanName || "Map");
            setCurrent(defaultPlan);
          }
        }
        firstLoad.current = true;
      })
      .catch(() => setLoading(false))
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (asset) {
      firstLoad.current = false;
      onSearch("");
    }
  }, [asset]);

  useEffect(() => {
    if (showDefault) {
      onSearch("");
    }
  }, [showDefault]);

  useEffect(() => {
    const handleClick = () => {
      setShowing(false);
      cancelOption && cancelOption();
    };

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
      setLoading(false);
      isUnmount.current = true;
    };
  }, []);

  useEffect(() => {
    setShowing(false);
  }, [showOptions]);

  return (
    <React.Fragment>
      <MapControl
        position={right ? ControlPosition.TOP_RIGHT : ControlPosition.TOP_LEFT}
      >
        <div style={{ background: "#ffffffff", margin: "10px" }}>
          <DebounceInput
            className="hashtag-input text-gray w-100"
            style={{
              border: "1px solid #7f838e",
              padding: "4px 8px",
              fontSize: "12px",
              height: "32px",
            }}
            minLength={0}
            debounceTimeout={300}
            value={searchString}
            placeholder="Search floorplans"
            onClick={(e) => e.stopPropagation()}
            onFocus={(e) => {
              setShowing(true);
            }}
            onChange={(event) => {
              onSearch(event.target.value);
            }}
          />

          {loading && (
            <div className="w-100 bg-light d-flex justify-content-center p-2">
              <Spinner animation="border" />
            </div>
          )}

          <div style={{ maxHeight: "400px" }} className="overflow-auto">
            {showing && (
              <ListGroup>
                {data &&
                  data.length > 0 &&
                  data.map((item, index) => (
                    <ListGroup.Item
                      onClick={(event) => {
                        event.stopPropagation();
                        if (!(current && item.id === current.id)) {
                          setSearchString(item.floorPlanName);
                          // console.log("select", { item, props });
                          onSelect && onSelect(item);
                          setCurrent(item);
                        }
                        setShowing(false);
                      }}
                      key={index}
                      className={`cursor-pointer list-group-hover ${
                        current && item.id === current.id ? "bg-primary" : ""
                      }`}
                    >
                      <Image size={14} />
                      <span className="ms-1">{item.floorPlanName}</span>
                    </ListGroup.Item>
                  ))}
                {showMap && (
                  <ListGroup.Item
                    onClick={(event) => {
                      event.stopPropagation();
                      setSearchString("Map");
                      onSelect && onSelect(null);
                      setShowing(false);
                      setCurrent(null);
                    }}
                    className={`cursor-pointer list-group-hover ${
                      !current ? "bg-primary" : ""
                    }`}
                  >
                    <Map size={14} />
                    <span className="ms-1">Map</span>
                  </ListGroup.Item>
                )}
              </ListGroup>
            )}
          </div>
        </div>
      </MapControl>
    </React.Fragment>
  );
};

export default FloorplanSelectControl;
